import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import * as React from 'react';

import HtmlContent from '../HtmlContent';

interface Props {
    title: string;
    description: string;
    collapsibleIcon?: React.ReactNode;
    headerIcon?: React.ReactNode;
}

const InformationCollapsible: React.FC<Props> = ({ headerIcon, title, description, collapsibleIcon }) => {
    return (
        <Accordion
            sx={[
                { width: '100%', marginTop: '10px', borderRadius: '4px' },
                {
                    '&::before': {
                        height: 0,
                    },
                },
            ]}
            elevation={2}
        >
            <AccordionSummary
                sx={[
                    { width: '100%', fontWeight: 500 },
                    {
                        '& .MuiIconButton-root': {
                            padding: '0 12px',
                        },
                        '& .MuiIconButton-label': {
                            width: '16px',
                            display: 'block',
                        },
                        '& .MuiAccordionSummary-content': {
                            alignItems: 'center',
                        },
                        '& .MuiAccordionSummary-expandIconWrapper': {
                            width: '15px',
                        },
                        '& .ddbc-information-collapsible__header-icon': {
                            display: 'flex',
                            alignItems: 'center',
                            '& .ddbc-svg': {
                                width: '24px',
                                marginRight: '16px',
                            },
                        },
                    },
                ]}
                expandIcon={collapsibleIcon ? collapsibleIcon : <ExpandMoreIcon />}
                aria-controls={`${title}-content`}
                id={`${title}-header`}
            >
                {headerIcon && <span className="ddbc-information-collapsible__header-icon">{headerIcon}</span>}
                {title}
            </AccordionSummary>
            <AccordionDetails>
                <HtmlContent html={description} />
            </AccordionDetails>
        </Accordion>
    );
};

export default InformationCollapsible;
